"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomRepetitionDialog = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const CustomRepetitionType_1 = __importDefault(require("@opsbase/lib-time/CustomRepetitionType"));
const createCustomRepetition_1 = __importDefault(require("@opsbase/lib-time/helpers/createCustomRepetition"));
const useLocalProp_1 = __importDefault(require("@opsbase/react-hooks/useLocalProp"));
const Dialog_1 = __importDefault(require("@opsbase/web-dialogs/Dialog"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const FieldSet_1 = __importDefault(require("@opsbase/web-ui/FieldSet"));
const react_1 = __importStar(require("react"));
const CustomRepetitionLabel_1 = __importDefault(require("../CustomRepetitionLabel"));
const CustomRepetitionTypePicker_1 = __importDefault(require("./CustomRepetitionTypePicker"));
const DatesOfMonthPicker_1 = __importDefault(require("./DatesOfMonthPicker"));
const MonthsOfYearPicker_1 = __importDefault(require("./MonthsOfYearPicker"));
const WeekdaysPicker_1 = __importDefault(require("./WeekdaysPicker"));
const WeeksOfMonthPicker_1 = __importDefault(require("./WeeksOfMonthPicker"));
const CustomRepetitionDialog = function (props) {
    const { dueDate, customRepetition: cr, onChange } = props, otherProps = __rest(props, ["dueDate", "customRepetition", "onChange"]);
    const [customRepetition, setCustomRepetition] = (0, useLocalProp_1.default)(cr || (0, createCustomRepetition_1.default)());
    const type = customRepetition === null || customRepetition === void 0 ? void 0 : customRepetition.customRepetitionType;
    const handleChangeType = (0, react_1.useCallback)(customRepetitionType => {
        setCustomRepetition(Object.assign(Object.assign({}, customRepetition), { customRepetitionType }));
    }, [customRepetition, setCustomRepetition]);
    const handleChangeWeekdays = (0, react_1.useCallback)(weekdays => {
        setCustomRepetition(Object.assign(Object.assign({}, customRepetition), { weekdays }));
    }, [customRepetition, setCustomRepetition]);
    const handleChangeWeeksOfMonth = (0, react_1.useCallback)(weeksOfMonth => {
        setCustomRepetition(Object.assign(Object.assign({}, customRepetition), { weeksOfMonth }));
    }, [customRepetition, setCustomRepetition]);
    const handleChangeDatesOfMonth = (0, react_1.useCallback)((datesOfMonth, last) => {
        setCustomRepetition(Object.assign(Object.assign({}, customRepetition), { datesOfMonth, last: last }));
    }, [customRepetition, setCustomRepetition]);
    const handleChangeMonthsOfYear = (0, react_1.useCallback)(monthsOfYear => {
        setCustomRepetition(Object.assign(Object.assign({}, customRepetition), { monthsOfYear }));
    }, [customRepetition, setCustomRepetition]);
    const handleConfirmClick = (0, react_1.useCallback)(() => {
        onChange(customRepetition);
    }, [onChange, customRepetition]);
    return (react_1.default.createElement(Dialog_1.default, Object.assign({}, otherProps, { white: true, padded: true, size: DialogSize_1.default.X550_Y500, buttonsRight: react_1.default.createElement(Button_1.default, { label: lib_i18n_1.default.t('ok'), onClick: handleConfirmClick }) }),
        react_1.default.createElement(Vertical_1.default, { padding: true, gutter: true },
            react_1.default.createElement(CustomRepetitionTypePicker_1.default, { value: type, onChange: handleChangeType }),
            type === CustomRepetitionType_1.default.WEEKLY && (react_1.default.createElement(FieldSet_1.default, null,
                react_1.default.createElement(WeekdaysPicker_1.default, { multi: true, weekdays: customRepetition.weekdays, onChange: handleChangeWeekdays }))),
            type === CustomRepetitionType_1.default.MONTHLY && (react_1.default.createElement(FieldSet_1.default, null,
                react_1.default.createElement(WeeksOfMonthPicker_1.default, { weeksOfMonth: customRepetition.weeksOfMonth, onChange: handleChangeWeeksOfMonth }),
                react_1.default.createElement(WeekdaysPicker_1.default, { weekdays: customRepetition.weekdays, onChange: handleChangeWeekdays }))),
            type === CustomRepetitionType_1.default.MONTHLY_BY_DATE && (react_1.default.createElement(FieldSet_1.default, null,
                react_1.default.createElement(DatesOfMonthPicker_1.default, { last: customRepetition.last, datesOfMonth: customRepetition.datesOfMonth, onChange: handleChangeDatesOfMonth }))),
            type === CustomRepetitionType_1.default.YEARLY && (react_1.default.createElement(Vertical_1.default, { shrink: true, gutter: true },
                react_1.default.createElement(FieldSet_1.default, null,
                    react_1.default.createElement(WeeksOfMonthPicker_1.default, { weeksOfMonth: customRepetition.weeksOfMonth, onChange: handleChangeWeeksOfMonth }),
                    react_1.default.createElement(WeekdaysPicker_1.default, { weekdays: customRepetition.weekdays, onChange: handleChangeWeekdays })),
                react_1.default.createElement(FieldSet_1.default, null,
                    react_1.default.createElement(MonthsOfYearPicker_1.default, { monthsOfYear: customRepetition.monthsOfYear, onChange: handleChangeMonthsOfYear })))),
            type === CustomRepetitionType_1.default.YEARLY_BY_DATE && (react_1.default.createElement(Vertical_1.default, { shrink: true, gutter: true },
                react_1.default.createElement(FieldSet_1.default, null,
                    react_1.default.createElement(DatesOfMonthPicker_1.default, { last: customRepetition.last, datesOfMonth: customRepetition.datesOfMonth, onChange: handleChangeDatesOfMonth })),
                react_1.default.createElement(FieldSet_1.default, null,
                    react_1.default.createElement(MonthsOfYearPicker_1.default, { monthsOfYear: customRepetition.monthsOfYear, onChange: handleChangeMonthsOfYear })))),
            react_1.default.createElement(Pane_1.default, { grow: true }),
            react_1.default.createElement(Pane_1.default, { scrollY: true, style: { maxHeight: 54 } },
                react_1.default.createElement(CustomRepetitionLabel_1.default, { dueDate: dueDate, customRepetition: customRepetition })))));
};
exports.CustomRepetitionDialog = CustomRepetitionDialog;
exports.default = exports.CustomRepetitionDialog;
